export const sectionTexts = {
  JP: {
    tours: {
      kicker: "Tours",
      title: "人気の体験",
    },
    reason: {
      kicker: "Reason",
      title: "このツアーが特別な理由",
    },
    customize: {
      kicker: "Customize",
      title: "撮りたい写真から旅日程をつくる",
    },
    memories: {
      kicker: "Memories",
      title: "一生残したい宮古島の瞬間",
    },
    booking: {
      kicker: "Booking",
      title: "予約方法",
    },
    experience: {
      kicker: "Tours",
      title: "宮古島で選べる特別な体験",
    },
    journal: {
      kicker: "Journal",
      title: "宮古島をもっと楽しむ島旅ガイド",
    },
  },

  EN: {
    tours: {
      kicker: "Tours",
      title: "Popular Experiences",
    },
    reason: {
      kicker: "Reason",
      title: "Why choose this tour",
    },
    customize: {
      kicker: "Customize",
      title: "Choose Your Tour by Photo Style",
    },
    memories: {
      kicker: "Memories",
      title: "Special Moments",
    },
    booking: {
      kicker: "Booking",
      title: "How to Reserve",
    },
    experience: {
      kicker: "Tours",
      title: "Special Experiences in Miyakoisland",
    },
    journal: {
      kicker: "Journal",
      title: "Miyakoisland Travel Guide",
    },
  },

  中文: {
    tours: {
      kicker: "Tours",
      title: "热门体验",
    },
    reason: {
      kicker: "Reason",
      title: "这个行程的特别之处",
    },
    customize: {
      kicker: "Customize",
      title: "根据想拍的照片选择行程",
    },
    memories: {
      kicker: "Memories",
      title: "值得一生珍藏的宫古岛瞬间",
    },
    booking: {
      kicker: "Booking",
      title: "预约方法",
    },
    experience: {
      kicker: "Tours",
      title: "在宫古岛可选择的特别体验",
    },
    journal: {
      kicker: "Journal",
      title: "宫古岛旅行指南",
    },
  },

  한국어: {
    tours: {
      kicker: "Tours",
      title: "인기 체험",
    },
    reason: {
      kicker: "Reason",
      title: "이 투어가 특별한 이유",
    },
    customize: {
      kicker: "Customize",
      title: "원하는 사진 스타일로 투어 선택",
    },
    memories: {
      kicker: "Memories",
      title: "평생 간직하고 싶은 미야코지마의 순간",
    },
    booking: {
      kicker: "Booking",
      title: "예약 방법",
    },
    experience: {
      kicker: "Tours",
      title: "미야코지마에서 즐길 수 있는 특별한 체험",
    },
    journal: {
      kicker: "Journal",
      title: "미야코지마 여행 가이드",
    },
  },
};

export const getSectionText = (lang, key) => {
  return sectionTexts[lang]?.[key] || sectionTexts.JP[key];
};
